<template>
    <Card :title="$t('labels.expense')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.name')">
                        <Input
                            v-model="name"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.sum')">
                        <Input
                            v-model="sum"
                            type="number"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.type')">
                        <AppSelect
                            :model-value="type?.value"
                            :selected-value="type?.label"
                            @update:model-value="type = $event"
                            :options="expenseTypeOptions"
                            option-key="value"
                            option-value="label"
                            :can-be-empty="true"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="light" class="mr-2" @click="deleteExpense">
                {{ $t('buttons.delete') }}
            </Button>
            <Button color="indigo" @click="updateExpense">
                {{ $t('buttons.edit') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import Input from "../../../../../components/new/form/Input.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import AppSelect from "../../../../../components/new/form/select/AppSelect.vue";

import { httpClient } from "../../../../../services/HttpClient";
import { OrderExpenseTypeEnum } from "../../../../enums/OrderExpenseTypeEnum";

export default {
    name: 'OrderExpenseEditPage',
    components: {
        Card, Input, FormGroup, Button, AppSelect
    },
    data() {
        return {
            name: '',
            sum: 0,
            type: null,
            expenseTypeOptions: [
                { value: OrderExpenseTypeEnum.SMS_SENDING, label: this.$t('enums.OrderExpenseTypeEnum.sms_sending') },
                { value: OrderExpenseTypeEnum.MARKETPLACE_COMMISSION, label: this.$t('enums.OrderExpenseTypeEnum.marketplace_commission') },
                { value: OrderExpenseTypeEnum.PRODUCTS_COST, label: this.$t('enums.OrderExpenseTypeEnum.products_cost') },
            ],
        }
    },
    methods: {
        async fetchExpense() {
            await httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/expenses/${this.$route.params.orderExpenseUuid}`)
                .then(response => {
                    this.name = response.data.data.name;
                    this.sum = response.data.data.sum;
                    const typeValue = response.data.data.type;
                    this.type = typeValue
                        ? this.expenseTypeOptions.find(o => o.value === typeValue) ?? null
                        : null;
                });
        },
        async updateExpense() {
            await httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/expenses/${this.$route.params.orderExpenseUuid}`, {
                name: this.name,
                sum: this.sum,
                order_uuid: this.$route.params.orderUuid,
                type: this.type?.value ?? null,
            }).then(() => {
                this.name = '';
                this.sum = 0;
                this.type = null;
                this.$router.push({ name: 'OrderExpensesIndexPage' });
            })
        },
        async deleteExpense() {
            await httpClient.delete(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/expenses/${this.$route.params.orderExpenseUuid}`)
                .then(() => {
                    this.$router.push({ name: 'OrderExpensesIndexPage' });
                });
        }
    },
    mounted() {
        this.fetchExpense();
    },
}
</script>